import { ApiError, fetchWithAuth } from "@entities/user-tokens";

import type { PresignedPost, SlideFormat } from "../SlideFormat";

/** 既存フォーマットの PPTX 差し替え用 presigned POST を取得する（status → uploading）。 */
export async function reuploadSlideFormat(
    formatId: string
): Promise<{ slideFormat: SlideFormat; upload: PresignedPost }> {
    const res = await fetchWithAuth(`/slide-formats/${formatId}/upload`, {
        method: "POST",
        headers: { Accept: "application/json" },
    });
    if (!res.ok) throw await ApiError.fromResponse(res, "再アップロードの準備に失敗しました");
    return (await res.json()) as { slideFormat: SlideFormat; upload: PresignedPost };
}
